export default __webpack_public_path__ + "static/media/github.263b2bfa.svg";